import { CHF } from 'lib/utilities'
import React from 'react'
import { Table } from 'semantic-ui-react'

export default class DealerFooter extends React.PureComponent {
  render() {
    const { data } = this.props
    return (
      <Table.Footer>
        <Table.Row>
          <Table.Cell colSpan={5} textAlign="right">
            Summe Produkte
          </Table.Cell>
          <Table.Cell textAlign="right">{CHF(data.bop_sum)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell colSpan={5} textAlign="right">
            BOP-Zuschlag
          </Table.Cell>
          <Table.Cell textAlign="right">{CHF(data.bop_surcharge)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell colSpan={5} textAlign="right">
            Versandkosten
          </Table.Cell>
          <Table.Cell textAlign="right">{CHF(data.shipping)}</Table.Cell>
        </Table.Row>
        <Table.Row>
        <Table.Cell colSpan={5} textAlign="right">
          Summe Netto
        </Table.Cell>
        <Table.Cell textAlign="right">{CHF(data.bop_total)}</Table.Cell>
        </Table.Row>
        <Table.Row className="unobtrusive">
          <Table.Cell colSpan={5} textAlign="right">
            MwSt.
          </Table.Cell>
          <Table.Cell textAlign="right">
            <strong>{CHF(data.bop_vat)}</strong>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell colSpan={5} textAlign="right">
            <strong>Total</strong>
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            <strong>{CHF(data.bop_total_sum_incl_vat)}</strong>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CustomerCart/DealerFooter.jsx